import { gql } from '@apollo/client';

export default gql`
  mutation createUserSettings($userSettings: NewUserBioIn!) {
    createUserSettings(userSettings: $userSettings)
  }
`;
